import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Typography,
  Checkbox,
  Box,
  Grid
} from '@material-ui/core';
import CircularCenteredLoader from 'features/common/CircularCenteredLoader';
import { getCasesFromCourtUpdate } from 'features/Tdsat/API/TdsatApi';
import validateDateAndFormat from 'utils/validateDateAndFormat';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  tableHeadItem:{
		// color: 'grey',
		fontSize: '15px',
		fontFamily: 'Satoshi-Bold',
	},
	tableRowValue: {
		// color: '#858D98',
		fontSize: '14px',
	},
	valuePaper: {
		padding: "0.7rem 8px",
		cursor: "pointer",
		boxShadow: "none",
		width: "100%",
		border: "1px solid #E0E0E0",
		[theme.breakpoints.down("sm")]: {
			textAlign: "center",
		},
	},
}));

const CasesFromCourtUpdate = ({listingDate, selectedCases, setSelectedCases}) => {
  const classes = useStyles();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);

  const spacing = [1,1,3,4,3];

  useEffect(()=>{
    if(listingDate){
      setLoading(true);
      getCasesFromCourtUpdate(format(listingDate, "dd-MM-yyyy"))
      .then((res)=>{
        // console.log(res.data);
        setCases(res.data);
        setLoading(false);
      })
      .catch((error)=>{
        console.log(error);
        setLoading(false);
      })
    }
  },[listingDate])

  const handleSelectAll = (event) => {
    event.stopPropagation();
    if (event.target.checked) {
      setSelectedCases(cases.map(item => ({
        id: item?.id,
        case_type: item?.case_type
      })));
    } else {
      setSelectedCases([]);
    }
  }

  const tableHeadings = [
    <Checkbox
      color="primary"
      style={{padding:'5px'}}
      checked={cases.length === selectedCases.length && selectedCases?.length > 0}
      onChange={handleSelectAll}
    />,
    'Sr. No.',
    'Case No.',
    'Case Name',
    'Court Updated On',
  ];
  
  const handleChangeOnFileCheckbox = (event, caseItem) => {
    event.stopPropagation();
    if (event.target.checked) {
      setSelectedCases(prev => [
        ...prev,
        { id: caseItem?.id, case_type: caseItem?.case_type }
      ]);
    } else {
      setSelectedCases(prev =>
        prev.filter(obj => obj.id !== caseItem.id)
      );
    }
  };

  const processResponse = (data,index) => {
    const item = data;
    const isSelected = selectedCases?.some(obj => obj.id === item.id);
    const arr = [
      <Checkbox
        id={item.id}
        color="primary"
        style={{ padding: "5px", height: "fit-content" }}
        checked={isSelected}
        onChange={(e)=>handleChangeOnFileCheckbox(e, item)}
      />,
      index+1, 
      item?.case_number,  
      item?.case_name,
      validateDateAndFormat(item?.court_updated_on,"dd/MM/y"), 
    ];
    return arr;
  }
  
  if(loading) return <CircularCenteredLoader/>

  return (
    <>
      <Box style={{backgroundColor:'white'}}>
        <Box>
          <Typography style={{fontFamily:'Satoshi-Bold', fontSize:'1.1rem'}}>List of cases updated for the listing date of {format(listingDate, 'dd/MM/y')}</Typography>
          <Typography>Select the cases you want to list on this bench.</Typography>
        </Box>
        <Box>
          <Grid container style={{ rowGap: "8px" }}>
            <Box style={{padding:'0.7rem 8px', width: '100%'}}>
              <Grid container spacing={1} justifyContent="flex-start">
                {tableHeadings.map((heading,index)=>{
                  return (
                    <Grid key={index} item xs sm={spacing[index]}>
                      <Typography className={classes.tableHeadItem}>
                        {heading}
                      </Typography>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
            {loading ? (
              <Box style={{margin:'auto',width:'100%',padding:'2rem 0'}}>
                <CircularCenteredLoader/>
              </Box>
            ) : (
              cases.length !== 0 ? (
                cases.map((dispute,index) => {
                  const processedDispute = processResponse(dispute,index);
                  return (
                    <Box key={index} className={classes.valuePaper}>
                      <Grid container spacing={1} justifyContent="flex-start" alignItems='center'>
                        {processedDispute.map((item,index)=>{
                          return (
                            <Grid key={index} item xs sm={spacing[index]}>
                              <Typography className={classes.tableRowValue}>
                                {item}
                              </Typography>
                            </Grid>
                          )
                        })}
                      </Grid>
                    </Box>
                  );
                })
              ) : (
                <Grid container justify="center">
                  <Grid item>
                    <Box textAlign="center">
                      <Typography
                        style={{
                          padding: '2rem 8px',
                          textAlign: 'center',
                          fontSize: '1.5rem'
                        }}
                      >
                        No case found.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default CasesFromCourtUpdate;

